<template>
  <div>
    <my-head></my-head>
    <img src="../../assets/Rectangle353.png" style="width: 100%" />
    <div class="capitaloperation minH">
      <div class="capital_title">知识产权资本运作</div>

      <div class="capital_content">
        知识产权资本运作又称知识产权资本经营，是将知识产权转化为生产力、技术力量、有形资产的重要手段。知识产权作为一种最重要的无形资产，越来越多的被运用到商业运作当中，且收效显著。
        <br /><br />
        企业知识产权资本运作即把知识产权作为投资、融资的工具，对知识产权进行资本化运作和操作，具体包括知识产权投资入股、信托以及证券化等。企业知识产权资本的有效运营是提高企业社会市场竞争力的关键，将企业知识产权运营的相关问题提高到战略高度，有利于确保企业充分发挥知识产权在企业发展中的重要作用。
        <br /><br />
        国家平台主要提供的知识产权资本运作服务包括：<br />
        1.帮助知识产权研究机构（高校）与企业建立互助关系，完善双方知识产权技术入股、转让、许可等方案及相关手续；<br />
        2.帮助各企业间完成知识产权战略合作、交叉许可、兼并等知产运作；<br />
        3.帮助个人与企业完成知识产权许可、转让、人才引进等知产运作；<br />
        4.帮助企业运用知识产权进行质押、贷款、投融资。<br />
      </div>

      <img src="../../assets/capital_1.png" class="capital_img" alt="" />

      <div class="capital_title_1">对接机构</div>
    </div>
    <my-footer></my-footer>
  </div>
</template>

<script>
import MyHead from "../../components/MyHead.vue";
import MyFooter from "../../components/MyFooter.vue";
export default {
  components: { MyHead, MyFooter },
  data() {
    return {};
  },
};
</script>

<style lang="scss">
.capitaloperation {
  width: 80%;
  margin: 48px auto 100px;
  .capital_title_1 {
    font-size: 20px;
    font-weight: 500;
    color: #1d2129;
    line-height: 28px;
  }
  .capital_img {
    width: 100%;
    margin-bottom: 32px;
  }
  .capital_content {
    font-size: 14px;
    margin-bottom: 32px;
    font-weight: 400;
    color: #4e5969;
    line-height: 28px;
  }
  .capital_title {
    font-size: 24px;
    font-weight: bold;
    color: #1d2129;
    line-height: 32px;
    margin-bottom: 24px;
  }
}
</style>
